import { Col, Dropdown, Modal, Space, Typography, message } from "antd";
import { useState } from "react";
import { Guid } from "guid-typescript";
import ProcessAssignmentsView from "../components/ProcessAssignmentsView";
import RoadmapCompanyView from "../components/RoadmapCompanyView";
import RoadmapAssignmentManage from "../components/processes/RoadmapAssignmentManage";
import { SearchQuery } from "../code/search-query/search-query";
import { getRoadmapCompaniesExport } from "../repository/data.repository";
import { getProblemMessage } from "../utils/http";
import Loader from "../controls/Loader";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";

// The operations surface: assign roadmaps to companies + a per-company Manage surface
// (progress control + assessment review).
function ProcessAssignmentsPage() {
  const [modal, contextHolder] = Modal.useModal();
  const [inputMode, setInputMode] = useState<"add" | "delete">("add");
  const [inputOpen, setInputOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState<SearchQuery>({ conditions: [] });
  const [inputUid, setInputUid] = useState<string | null | undefined>(null);
  const [manageUid, setManageUid] = useState<string | null>(null);
  const [triggerView, setTriggerView] = useState(Guid.create().toString());
  const permissions = useSelector(authorizeSelectors.permissions);

  function refresh(): void {
    setTriggerView(Guid.create().toString());
  }

  function onSearch(searchQuery: SearchQuery): void {
    setSearchQuery(searchQuery);
  }

  function onAction(key: string, record: any): void {
    if (key === "manage") {
      setManageUid(record.uid);
      return;
    }
    // delete
    setInputMode("delete");
    setInputUid(record?.uid);
    setInputOpen(true);
  }

  function onAdd(): void {
    setInputMode("add");
    setInputUid(null);
    setInputOpen(true);
  }

  function onFinish(): void {
    setInputOpen(false);
    refresh();
  }

  function onClose(): void {
    setInputOpen(false);
  }

  function onManageClose(): void {
    setManageUid(null);
    refresh();
  }

  function onDownloadExport(): void {
    const loading = modal.info({
      content: (
        <Typography.Text className="m-1 ml-2 inline-block">
          Downloading export file..
        </Typography.Text>
      ),
      footer: null,
      centered: true,
      icon: <Loader />,
    });
    getRoadmapCompaniesExport({
      searchQuery,
      pageNumber: 0,
      pageSize: Number.MAX_SAFE_INTEGER,
    })
      .then(() => loading.destroy())
      .catch((err) => {
        loading.destroy();
        message.error(getProblemMessage(err) || "Failed to download export.");
      });
  }

  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <Col className="flex flex-auto flex-col overflow-hidden p-4 pb-4 pt-0">
        <ProcessAssignmentsView
          trigger={triggerView}
          title={"Assignments"}
          panel={
            <Space className="flex flex-auto flex-row justify-end">
              <Dropdown.Button
                type="primary"
                className={`${!permissions.can("ProcessesAssignment", "create") ? "disabled" : ""}`}
                disabled={!permissions.can("ProcessesAssignment", "create")}
                menu={{
                  items: [
                    {
                      key: "downloadExport",
                      label: "Export to Excel",
                      disabled: !permissions.can("ProcessesAssignment", "view"),
                      onClick: onDownloadExport,
                    },
                  ],
                }}
                onClick={onAdd}
              >
                Assign Company
              </Dropdown.Button>
            </Space>
          }
          onAction={onAction}
          onSearch={onSearch}
        />
      </Col>

      <RoadmapCompanyView
        key={inputMode}
        mode={inputMode}
        open={inputOpen}
        uid={inputUid}
        onFinish={onFinish}
        onClose={onClose}
      />
      <RoadmapAssignmentManage open={!!manageUid} uid={manageUid} onClose={onManageClose} />
      {contextHolder}
    </Col>
  );
}

export default ProcessAssignmentsPage;
